// tslint:disable-next-line:no-any
export function isFieldValueEmpty(value: any): boolean {
  return (value === null) || (value === undefined) || (value === '') ;
}
